import { PostPermission, PostPermissionType } from "../types/postPermissionType";
import LoginUtil from "./loginUtil";

/**
 * 投稿許可設定に関連するUtilクラス。
 */
export default class PostPermissionUtil {
	/**
	 * 投稿可能かどうかを判断する。
	 * @param postPermissionSetting 投稿許可設定
	 * @param postPermissionSpecificECMemberIds 投稿可能なEC会員IDリスト
	 * @param nonMemberIdList 非会員IDリスト
	 * @param siteUserId サイトログインID
	 * @returns 投稿可能:`true`, 投稿不可能:`false`
	 */
	public static isPostable(postPermissionSetting: PostPermissionType, postPermissionSpecificECMemberIds: string[], nonMemberIdList: string[], siteUserId: string | null | undefined): boolean {
		switch (postPermissionSetting) {
			case PostPermission.all:
				// 全員許可の場合、テナント会員IDに関わらずOKとする
				return true;
			case PostPermission.onlyEcMember:
				// EC会員のみ可能の場合、会員IDを参照しログイン状態であればOKとする
				if (LoginUtil.isLogin(siteUserId, nonMemberIdList)) {
					return true;
				} else {
					return false;
				}
			case PostPermission.onlySpecificEcMember:
				if (siteUserId === null || siteUserId === undefined) {
					return false;
				}
				// 特定のEC会員のみ可能の場合、特定EC会員であればOKとする
				if (postPermissionSpecificECMemberIds.includes(siteUserId)) {
					return true;
				} else {
					return false;
				}
			default:
				throw new Error(`PostPermissionUtil.isPostableにて想定外の値が渡されました。postPermissionSetting: ${postPermissionSetting}`);
		}
	}

	/**
	 * 投稿フォームを表示するかどうかを判断する。
	 * @param postPermissionSetting 投稿許可設定
	 * @param postPermissionSpecificECMemberIds 投稿可能なEC会員IDリスト
	 * @param siteUserId サイトログインID
	 * @returns フォームを非表示にする:`true`, 非表示にしない:`false`
	 */
	public static isFormVisible(postPermissionSetting: PostPermissionType, postPermissionSpecificECMemberIds: string[], siteUserId: string | null | undefined): boolean {
		switch (postPermissionSetting) {
			case PostPermission.all:
			case PostPermission.onlyEcMember:
				// 全員許可の場合、投稿フォームを表示する
				// EC会員のみ可能の場合、ログイン訴求UIを出すためフォームは表示する
				return true;
			case PostPermission.onlySpecificEcMember:
				// 特定EC会員のみ可能の場合、特定EC会員以外のユーザーだとクライアント側からは投稿するためのアクションを取れないため、フォームも表示しない
				if (siteUserId === null || siteUserId === undefined) {
					return false;
				}
				if (postPermissionSpecificECMemberIds.includes(siteUserId)) {
					return true;
				} else {
					return false;
				}
			default:
				throw new Error(`PostPermissionUtil.isFormVisibleにて想定外の値が渡されました。postPermissionSetting: ${postPermissionSetting}`);
		}
	}
}
